// extracted by mini-css-extract-plugin
module.exports = {"workoutPageControls":"WorkoutPageControls_workoutPageControls__2k6JS","back":"WorkoutPageControls_back__jHpk4"};